import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "modal is-active" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "modal-background" }, null, -1);
const _hoisted_3 = { class: "modal-card" };
const _hoisted_4 = { class: "modal-card-head" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "modal-card-title" }, "Login", -1);
const _hoisted_6 = { class: "modal-card-body" };
const _hoisted_7 = { class: "field" };
const _hoisted_8 = { class: "control has-icons-left" };
const _hoisted_9 = { class: "icon is-small is-left" };
const _hoisted_10 = { class: "field" };
const _hoisted_11 = { class: "control has-icons-left" };
const _hoisted_12 = { class: "icon is-small is-left" };
const _hoisted_13 = { class: "modal-card-foot is-flex is-justify-content-space-around" };
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import BulmaButton from "@/bulma/Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginModal',
    emits: ["cancel", "submit"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const mail = ref("");
        const password = ref("");
        const mail_input = ref(null);
        function on_keydown(e) {
            if (e.key == "Enter")
                submit();
            else if (e.key == "Escape")
                cancel();
        }
        onMounted(() => {
            window.addEventListener("keydown", on_keydown);
            nextTick(() => {
                if (!(mail_input.value instanceof HTMLElement))
                    return;
                mail_input.value.focus();
            });
        });
        onBeforeUnmount(() => window.removeEventListener("keydown", on_keydown));
        function submit() {
            emit("submit", { mail: mail.value, password: password.value });
        }
        function cancel() {
            emit("cancel");
        }
        return (_ctx, _cache) => {
            const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("header", _hoisted_4, [
                        _hoisted_5,
                        _createElementVNode("button", {
                            class: "delete",
                            onClick: _withModifiers(cancel, ["left"])
                        })
                    ]),
                    _createElementVNode("article", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("p", _hoisted_8, [
                                _withDirectives(_createElementVNode("input", {
                                    ref_key: "mail_input",
                                    ref: mail_input,
                                    class: "input",
                                    type: "email",
                                    placeholder: "E-Mail",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((mail).value = $event))
                                }, null, 512), [
                                    [_vModelText, mail.value]
                                ]),
                                _createElementVNode("span", _hoisted_9, [
                                    _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'envelope'] })
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("p", _hoisted_11, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "input",
                                    type: "password",
                                    placeholder: "Passwort",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((password).value = $event))
                                }, null, 512), [
                                    [_vModelText, password.value]
                                ]),
                                _createElementVNode("span", _hoisted_12, [
                                    _createVNode(_component_FontAwesomeIcon, { icon: ['fas', 'lock'] })
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("footer", _hoisted_13, [
                        _createVNode(BulmaButton, {
                            class: "is-success",
                            onClick: _withModifiers(submit, ["left"]),
                            icon: ['fas', 'unlock'],
                            text: "Login"
                        }),
                        _createVNode(BulmaButton, {
                            class: "is-danger",
                            onClick: _withModifiers(cancel, ["left"]),
                            icon: ['fas', 'circle-xmark'],
                            text: "Abbrechen"
                        })
                    ])
                ])
            ]));
        };
    }
});
